module.exports = __webpack_public_path__ + "img/KI.1e425fd5.svg";